<template>
  <svg
    version="1.1"
    id="レイヤー_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    :width="`${size}px`"
    :height="`${size}px`"
    viewBox="0 0 24 24"
    style="enable-background: new 0 0 24 24"
    xml:space="preserve"
  >
    <g id="グループ_695" transform="translate(0)">
      <g id="グループ_689" transform="translate(0 0)">
        <g id="グループ_680">
          <path
            id="パス_24"
            :style="{
              fill: colors[0],
            }"
            d="M8,4.8V3H2.3v1.8H0.1v14.7h10.1V4.8H8z M8.7,18H1.6V6.3h2.2V4.5h2.7v1.8h2.2L8.7,18L8.7,18z"
          />
          <path
            id="パス_25"
            :style="{
              fill: colors[0],
            }"
            d="M6.2,8.3l-2.8,3.9L5,12.6l-0.5,2.9L7,11.8l-1.6-0.5L6.2,8.3z"
          />
        </g>
      </g>
      <g id="グループ_690" transform="translate(21.688 9.406)">
        <g id="グループ_26">
          <path
            id="パス_30"
            :style="{
              fill: colors[0],
            }"
            d="M-2.3,1.1c-1,0-1.9-0.3-2.7-0.9c-0.8-0.8-1.9-1-3.2-0.6C-8.8-0.2-9.4,0.1-10,0.5
				c-0.2,0.2-0.6,0.1-0.8-0.1c-0.2-0.2-0.1-0.6,0.1-0.8c0.7-0.5,1.4-0.8,2.2-1C-6.8-2-5.3-1.7-4.2-0.6c0.5,0.4,1.5,0.9,3.4,0.4
				C0-0.4,0.8-0.7,1.5-1c0.3-0.1,0.6,0,0.7,0.2C2.4-0.5,2.3-0.2,2,0l0,0C0.7,0.6-0.8,1-2.3,1.1z"
          />
          <path
            id="パス_31"
            :style="{
              fill: colors[0],
            }"
            d="M1.1,1.5C0.8,1.5,0.5,1.3,0.5,1c0-0.1,0-0.2,0-0.2l0.4-1L0-0.7c-0.3-0.1-0.4-0.4-0.3-0.7
				s0.4-0.4,0.7-0.3L2-1.1c0.3,0.1,0.4,0.4,0.3,0.7L1.6,1.2C1.5,1.4,1.3,1.5,1.1,1.5z"
          />
        </g>
        <g id="グループ_27" transform="translate(0 7.09)">
          <path
            id="パス_32"
            :style="{
              fill: colors[0],
            }"
            d="M-2.3-2.5c-1,0-1.9-0.3-2.7-0.9c-0.8-0.8-1.9-1-3.2-0.6C-8.8-3.8-9.4-3.5-10-3.1
				c-0.2,0.2-0.6,0.1-0.8-0.1C-11-3.5-10.9-3.8-10.7-4c0.7-0.5,1.4-0.8,2.2-1c1.7-0.5,3.2-0.2,4.3,0.8c0.5,0.4,1.5,0.9,3.4,0.4
				C0-4,0.8-4.3,1.5-4.6c0.3-0.1,0.6,0,0.7,0.2s0,0.6-0.2,0.7C0.7-3-0.8-2.6-2.3-2.5z"
          />
          <path
            id="パス_33"
            :style="{
              fill: colors[0],
            }"
            d="M1.1-2.1c-0.3,0-0.6-0.2-0.6-0.6c0-0.1,0-0.2,0-0.2l0.4-1L0-4.3c-0.3-0.1-0.4-0.4-0.3-0.7
				s0.4-0.4,0.7-0.3L2-4.7c0.3,0.1,0.4,0.4,0.3,0.7L1.6-2.4C1.5-2.2,1.3-2.1,1.1-2.1z"
          />
        </g>
        <g id="グループ_28" transform="translate(0 14.18)">
          <path
            id="パス_34"
            :style="{
              fill: colors[0],
            }"
            d="M-2.3-6.1c-1,0-1.9-0.3-2.7-0.9c-0.8-0.8-1.9-1-3.2-0.6C-8.8-7.4-9.4-7.1-10-6.7
				c-0.2,0.2-0.6,0.1-0.8-0.1c-0.2-0.2-0.1-0.6,0.1-0.8c0.7-0.5,1.4-0.8,2.2-1c1.7-0.5,3.2-0.2,4.3,0.8C-3.7-7.4-2.7-7-0.8-7.4
				C0-7.6,0.8-7.9,1.5-8.2c0.3-0.1,0.6,0,0.7,0.2c0.1,0.3,0,0.6-0.2,0.7l0,0C0.7-6.6-0.8-6.2-2.3-6.1z"
          />
          <path
            id="パス_35"
            :style="{
              fill: colors[0],
            }"
            d="M1.1-5.7c-0.3,0-0.6-0.2-0.6-0.6c0-0.1,0-0.2,0-0.2l0.4-1L0-7.9C-0.3-8-0.4-8.4-0.3-8.7
				s0.4-0.4,0.7-0.3l0,0L2-8.3c0.3,0.1,0.4,0.4,0.3,0.7L1.6-6C1.5-5.8,1.3-5.7,1.1-5.7z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'powerConsumption',
    props: {
      size: {
        type: Number,
        default: 20,
      },
      colors: {
        type: Array,
        default: () => ['#6F6F6F'],
      },
    },
  };
</script>
